import React, { useContext } from "react";
import DatePicker from "react-datepicker";
import Context from "./EventsProvider";
import { formatMonth } from "./helpers/date";
import { registerLocale } from  "react-datepicker";
import { fr } from 'date-fns/locale/fr';

const Calendar = () => {
	
	const { data: { language, datesWithEvents, selectedDate },
		actions: { setParams, setSelectedDate },
	} = useContext(Context);
	
	registerLocale("fr", fr);

	const handleMonthChange = (date) => {
		if (!date) return;

		const month = new Date(date).getMonth() + 1;
		const formattedMonth = formatMonth(month).number;
		const monthParam = `${formattedMonth}-${new Date(date).getFullYear()}`;

		setParams((currentValue) => {
			if (currentValue.location) {
				const newParams = { location: currentValue.location, month: monthParam, lang: currentValue.lang };
				return newParams;
			}
				
			return { month: monthParam, lang: currentValue.lang };
		});

		setSelectedDate(null);
	};

	const handleDateChange = (date) => {
		if (!date) return;
		const formattedDate = date.toLocaleDateString("en-GB");
		const dateParam = formattedDate.split('/').join('-');
		
		setParams((currentValue) => {
			const resetDate = date.getDate() === selectedDate?.getDate();
			
			if (resetDate) {
				const month = new Date(date).getMonth() + 1;
				const formattedMonth = formatMonth(month).number;
				const monthParam = `${formattedMonth}-${new Date(date).getFullYear()}`;
				
				if (currentValue.location) {
					const newParams = { location: currentValue.location, month: monthParam, lang: currentValue.lang };
					return newParams;
				}

				return { month: monthParam, lang: currentValue.lang };
			}
				
			if (currentValue.location) {
				const newParams = { location: currentValue.location, date: dateParam, lang: currentValue.lang };
				return newParams;
			}

			return { date: dateParam, lang: currentValue.lang };

		});

		setSelectedDate((currentValue) => {
			if (date.getDate() === currentValue?.getDate()) return null;
			return date;
		});
	};

	const daysClassName = (date) => {
		if (!datesWithEvents.length) return null;

		const formattedDate = date.toLocaleDateString("en-GB");
		const newDate = formattedDate.split('/').join('-');
		const hasNoEvent = !datesWithEvents.includes(newDate);
		return hasNoEvent ? 'no-event' : 'has-event';
	}

	return (
		<DatePicker
			selected={selectedDate}
			onSelect={handleDateChange}
			onMonthChange={handleMonthChange}
			minDate={new Date()}
			locale={language}
			inline
			dayClassName={daysClassName}
		/>
	);
};

export default Calendar;